module.exports = __webpack_public_path__ + "static/media/audio-7.47c55523.mp3";